import React, { useState } from 'react'
import newPassword from '../../Assets/forgotPassword/newPassword.svg';
import logo from '../../Assets/logo.png'
import { ButtonWithoutIcon } from '../../constents/components';
import useRouteFunctions from '../../Hooks/Routes/useRouteFunctions';
import Password from './Password';
import useSetNewPassword from '../../Hooks/useSetNewPassword';

const ResetPassword = ({ email }) => {
    const [loading, error, success, setNewPassword] = useSetNewPassword();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const { goToLoginPage } = useRouteFunctions();

    const submitRequest = async (e) => {
        e.preventDefault();
        try {
            await setNewPassword(email, password);
            goToLoginPage();
        }
        catch (err) {
            // console.log(err);
        }
    }

    return (
        <div className='h-screen w-screen flex flex-col md:flex-row'>
            <div className='bg-pills-bg-color-900 flex flex-col items-center py-4 px-4 md:w-1/2 md:justify-center'>
                <div className='mb-2 md:mb-6'>
                    <img src={logo} alt="Zepcruit logo" className='h-8 md:hidden md:h-10' />
                </div>
                <div className='w-full max-w-md my-4 md:my-8'>
                    <img src={newPassword} alt="Reset password illustration" className='w-44 max-w-xs mx-auto md:w-96' />
                </div>
                <h2 className='font-semibold text-center mt-4 mb-1 text-lg md:text-3xl'>Recruitment is Time-Consuming, but Not with Zepcruit</h2>
            </div>


            <div className='flex-1 flex flex-col items-center justify-between px-4 py-6 bg-white-bg-color md:w-1/2 md:py-20'>
                <div className='w-full max-w-md md:max-w-lg'>

                    <div className='hidden md:block md:text-center md:mb-10'>
                        <img src={logo} alt="Zepcruit logo" className='h-10 inline-block' />
                    </div>

                    <h3 className='text-2xl font-bold text-center mb-2 md:text-3xl'>Set New Password</h3>
                    <p className='md:block text-text-color-strong text-xs text-center mb-6'>
                        Set a strong new password for your account.
                    </p>

                    <form onSubmit={submitRequest} className='w-full'>
                        <div className='mb-6 space-y-5 md:mb-10'>
                            <Password
                                password={password}
                                setPassword={setPassword}
                                placeholder="Password"
                            // setEmailValid={setEmailValidation}
                            />
                            <Password
                                password={confirmPassword}
                                setPassword={setConfirmPassword}
                                placeholder="Confirm Password"
                            // setEmailValid={setEmailValidation}
                            />
                        </div>

                        <div className='mt-auto pt-20 md:pt-16 w-full'>
                            <ButtonWithoutIcon
                                classNames='w-full text-white-bg-color py-4 px-6 rounded-full font-medium bg-black hover:bg-gray-800'
                                text='Reset Password'
                                loading={loading}
                            // onClick={submitRequest}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;